import { render } from "./sanchan11.vue?vue&type=template&id=1a359ff2&scoped=true"
import script from "./sanchan11.vue?vue&type=script&lang=js"
export * from "./sanchan11.vue?vue&type=script&lang=js"

import "./sanchan11.vue?vue&type=style&index=0&id=1a359ff2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1a359ff2"

export default script